import { Route } from 'react-router';
import { RecipientWiresPage } from '../RecipientWiresPage';
import { getRecipientWiresPath } from '../path/path';
import { RecipientWireDetailsPage } from '../_Details/RecipientWireDetailsPage';
import { getRecipientWireDetailsPath } from '../_Details/path/path';

export const RecipientWireRoutes = [
  <Route key={getRecipientWiresPath()} path={getRecipientWiresPath()} element={<RecipientWiresPage />} />,
  <Route
    key={getRecipientWireDetailsPath()}
    path={getRecipientWireDetailsPath()}
    element={<RecipientWireDetailsPage />}
  />,
];
